<div class="flex flex-wrap gap-4">
  <div class="flex flex-col gap-4 rounded-lg bg-neutral-0 p-4 shadow-sm">
    <app-task-data-target (click)="navigateToMemberProfile()">
      <mat-icon icon>account_circle</mat-icon>
      <span text>{{ task.data.memberName }}</span>
    </app-task-data-target>
    <p>{{ task.data.memberPhoneNumber }}</p>
  </div>
  <div class="flex flex-col gap-4 rounded-lg bg-neutral-0 p-4 shadow-sm">
    <div class="flex gap-2 text-lg">
      <mat-icon>corporate_fare</mat-icon>
      {{ task.data.partnerName }}
    </div>
    @if (task.data.partnerName !== task.data.locationName) {
      <p>{{ task.data.locationName }}</p>
    }
    <p>{{ task.data.locationAddress }}</p>
    @if (task.data.partnerPhoneNumbers.length) {
      <div class="flex flex-col gap-1">
        @for (phone of task.data.partnerPhoneNumbers; track phone) {
          <p>{{ phone }}</p>
        }
      </div>
    }
  </div>
  <div class="flex flex-col gap-4 rounded-lg bg-neutral-0 p-4 shadow-sm">
    <div class="flex gap-2 text-lg">
      <mat-icon svgIcon="doctor" />
      {{ task.data.serviceName }}
    </div>
    <p>{{ task.data.doctorName }}</p>
    @if (task.data.appointmentStartDate) {
      <p>{{ formatDate(task.data.appointmentStartDate, true) }}</p>
    }
  </div>
</div>
